<h2 mat-dialog-title>Privacy Policy</h2>
<mat-dialog-content class="privacy-dialog-body">
  <iframe
    title="Boca Tennis Ladder Privacy Policy"
    src="/privacy-policy.html"></iframe>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</mat-dialog-actions>
